import { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { useInView } from "react-intersection-observer";
import { IMAGES } from "../../../../assets";

const Faqs = () => {
  const [ref, inView] = useInView({
    triggerOnce: true, // Trigger animation only once
    threshold: 0.3, // Trigger when 10% of the image is visible
  });
  const faqData = [
    {
      id: 1,
      question: "What to expect from an online astrology reading?",
      answer: "Online astrology readings typically provide personalized insights based on your birth chart, which is calculated based on the date, time, and place of your birth. You can expect guidance on areas like career, relationships, health, and personal growth, all delivered through a convenient digital platform."
    },
    {
      id: 2,
      question: "Is my personal information safe on your astrology app or website?",
      answer: "Yes, reputable astrology platforms prioritize user privacy and data security. Your birth details and personal information are encrypted and used solely to generate accurate astrological reports. Always check the app’s privacy policy for transparency."
    },
    {
      id: 3,
      question: "How accurate are the predictions made by the app?",
      answer: "The accuracy of astrological predictions usually depends on the quality of the birth data provided and the algorithms or astrologers behind the app. While astrology offers valuable guidance, it should be seen as a tool for reflection and decision-making, NOT a guarantee of future events."
    },
    {
      id: 4,
      question: "Can I get a live consultation with an astrologer through the app?",
      answer: "Many online astrology platforms offer live consultations via chat, phone, or video. These sessions allow you to ask very specific questions and receive real-time insights from professional astrologers."
    },
    {
      id: 5,
      question: "Do I need to know my exact birth time for an accurate reading?",
      answer: "While you can still receive general insights without your exact birth time, having it allows for a more precise birth chart and detailed predictions. If you're unsure, some apps offer birth time rectification services to help estimate the time of birth."
    },
  ];
  return (
    <section
      ref={ref}
      className={`accordian-section ${
        inView ? "animate__animated animate__slideInUp" : ""
      }`} id="faq"
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="accordian_content">
              <h4>Ask Something?</h4>
              <h2>Frequently Asked Questions</h2>
            </div>
          </div>
        </div>
        {/* <div className="row position-relative" data-aos="fade-up">
          <div className="col-lg-1 col-md-1 col-sm-1 d-lg-block d-none"></div>
          <div className="col-lg-10 col-md-12 col-sm-12 col-xs-12">
            <div className="accordian-section-inner position-relative">
              <div className="accordian-inner">
                <div id="accordion1">
                  <div className="accordion-card">
                    <div className="card-header" id="headingOne">
                      <a
                        href="#"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="false"
                        aria-controls="collapseOne"
                      >
                        <h6>Maiores alias conseuatur aut peruerendis?</h6>
                      </a>
                    </div>
                    <div
                      id="collapseOne"
                      className="collapse"
                      aria-labelledby="headingOne"
                    >
                      <div className="card-body">
                        <p className="pp text-left mb-0 p-0">
                          Incidunt ut labore et dolore magnam aliquam quaerat
                          voluptatem ut enim ad minima veniam, quis nostrum
                          exercitationem ullam corporis suscipit laboriosam,
                          nisi ut aliquid ex ea commodi consequatur accusantium
                          doloremque laudantium, totam rem aperiam, eaque ipsa
                          quae ab illo inventore veritatis et quasi.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-card">
                    <div className="card-header" id="headingTwo">
                      <a
                        href="#"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        <h6>Dolor renellendus temporibus autem zuibusdam?</h6>
                      </a>
                    </div>
                    <div
                      id="collapseTwo"
                      className="collapse"
                      aria-labelledby="headingTwo"
                    >
                      <div className="card-body">
                        <p className="pp text-left mb-0 p-0">
                          Incidunt ut labore et dolore magnam aliquam quaerat
                          voluptatem ut enim ad minima veniam, quis nostrum
                          exercitationem ullam corporis suscipit laboriosam,
                          nisi ut aliquid ex ea commodi consequatur accusantium
                          doloremque laudantium, totam rem aperiam, eaque ipsa
                          quae ab illo inventore veritatis et quasi.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-card">
                    <div className="card-header" id="headingThree">
                      <a
                        href="#"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        <h6>Officia deserunt mollitia animi est laborum?</h6>
                      </a>
                    </div>
                    <div
                      id="collapseThree"
                      className="collapse"
                      aria-labelledby="headingThree"
                    >
                      <div className="card-body">
                        <p className="pp text-left mb-0 p-0">
                          Incidunt ut labore et dolore magnam aliquam quaerat
                          voluptatem ut enim ad minima veniam, quis nostrum
                          exercitationem ullam corporis suscipit laboriosam,
                          nisi ut aliquid ex ea commodi consequatur accusantium
                          doloremque laudantium, totam rem aperiam, eaque ipsa
                          quae ab illo inventore veritatis et quasi.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-card">
                    <div className="card-header" id="headingFour">
                      <a
                        href="#"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        <h6>
                          Reiciendis voluptatibus maiores alias consequatur?
                        </h6>
                      </a>
                    </div>
                    <div
                      id="collapseFour"
                      className="collapse"
                      aria-labelledby="headingFour"
                    >
                      <div className="card-body">
                        <p className="pp text-left mb-0 p-0">
                          Incidunt ut labore et dolore magnam aliquam quaerat
                          voluptatem ut enim ad minima veniam, quis nostrum
                          exercitationem ullam corporis suscipit laboriosam,
                          nisi ut aliquid ex ea commodi consequatur accusantium
                          doloremque laudantium, totam rem aperiam, eaque ipsa
                          quae ab illo inventore veritatis et quasi.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-1 col-md-1 col-sm-1 d-lg-block d-none"></div>
          <figure className="mb-0 faq_shape">
            <img src={IMAGES.faq_icon} alt="" className="img-fluid" />
          </figure>
        </div> */}
        <div className="row position-relative" data-aos="fade-up">
          <div className="col-lg-1 col-md-1 col-sm-1 d-lg-block d-none"></div>
          <div className="col-lg-10 col-md-12 col-sm-12 col-xs-12">
            <div className="accordian-section-inner position-relative">
              <div className="accordian-inner">
                <div id="accordion1">
                  <Accordion defaultActiveKey="0">
                    {faqData.map((faq, index) => (
                    <Accordion.Item eventKey={faq.id.toString()} key={faq.id}>
                      <Accordion.Header>{faq.question}</Accordion.Header>
                      <Accordion.Body>{faq.answer}</Accordion.Body>
                    </Accordion.Item>
                    ))}
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-1 col-md-1 col-sm-1 d-lg-block d-none"></div>
          <figure className="mb-0 faq_shape">
            <img src={IMAGES.faq_icon} alt="" className="img-fluid" />
          </figure>
        </div>
      </div>
    </section>
  );
};

export default Faqs;
